import { StyleSheet } from "react-native";
import { theme } from "../../../theme/theme";
const style = () => {
    const { space2 } = theme();
    return StyleSheet.create({
        buttonIcon: {
            flexGrow: 0,
            padding: space2,
        },
    });
};
export { style };
